module.exports = __webpack_public_path__ + "img/83.905d9474.jpg";